var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaAvatar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4535198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4344 41.5868C31.7201 41.5868 40.8689 32.45 40.8689 21.1792C40.8689 9.90831 31.7201 0.771484 20.4344 0.771484C9.14881 0.771484 0 9.90831 0 21.1792C0 32.45 9.14881 41.5868 20.4344 41.5868Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.55521 24.5547C9.03538 24.5547 11.046 22.5468 11.046 20.0698C11.046 17.5929 9.03538 15.585 6.55521 15.585C4.07503 15.585 2.06445 17.5929 2.06445 20.0698C2.06445 22.5468 4.07503 24.5547 6.55521 24.5547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.8872 17.0606C23.3674 17.0606 25.378 15.0526 25.378 12.5757C25.378 10.0988 23.3674 8.09082 20.8872 8.09082C18.4071 8.09082 16.3965 10.0988 16.3965 12.5757C16.3965 15.0526 18.4071 17.0606 20.8872 17.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.0566 23.7279C37.789 23.7279 38.3827 23.1349 38.3827 22.4035C38.3827 21.6721 37.789 21.0791 37.0566 21.0791C36.3242 21.0791 35.7305 21.6721 35.7305 22.4035C35.7305 23.1349 36.3242 23.7279 37.0566 23.7279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.1082 16.2928C20.7062 16.2928 22.0016 14.9991 22.0016 13.4033C22.0016 11.8074 20.7062 10.5137 19.1082 10.5137C17.5102 10.5137 16.2148 11.8074 16.2148 13.4033C16.2148 14.9991 17.5102 16.2928 19.1082 16.2928Z",
    fill: "#5B5A61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.21368 22.1171C9.81165 22.1171 11.1071 20.8233 11.1071 19.2275C11.1071 17.6316 9.81165 16.3379 8.21368 16.3379C6.61572 16.3379 5.32031 17.6316 5.32031 19.2275C5.32031 20.8233 6.61572 22.1171 8.21368 22.1171Z",
    fill: "#5B5A61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.5639 19.0633C35.6995 17.7095 35.3053 16.3558 34.4638 15.2858L31.9924 11.132C31.7067 10.7693 31.567 10.3131 31.6006 9.85279C31.7004 9.56807 31.9012 9.3297 32.1649 9.18273C32.4287 9.03577 32.7372 8.99039 33.0322 9.05514C33.6151 9.21244 34.139 9.53682 34.5392 9.98823C35.5876 11.0036 36.4631 12.1829 37.1312 13.4798C37.7067 14.4519 37.9795 15.573 37.9148 16.7005C37.8683 17.2605 37.6447 17.7913 37.2763 18.2161C36.9079 18.6408 36.4137 18.9375 35.8653 19.0633H35.5639Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaAvatar2);
export default __webpack_public_path__ + "static/media/boba-avatar-2.9776652c.svg";
export { ForwardRef as ReactComponent };